import { Response } from '@/types';
import { BaseApiService } from './base-service';

type Time = {
  time: number
}

export class DateTimeService extends BaseApiService {
  private base_path = 'time';

  async get_time(): Promise<Response<Time>> {
    const { data } = await this.http_client.get<Response<Time>>(this.base_path);

    return data;
  }
}
